import { styled } from "styled-components";
import errorImage from "./error_id.svg";
import errorAltImage from "./error_auth.svg";

const Err = styled.img`
  width: 200px;
  height: 200px;
  display: block;
`;

const Wrapper = styled.div``;

export interface ErrorIconProps {
  variant?: "authentication" | "identification";
}

export function ErrorIcon({
  variant = "identification",
}: ErrorIconProps): JSX.Element {
  const src = variant === "authentication" ? errorAltImage : errorImage;
  return (
    <Wrapper>
      <Err src={src} alt="" />
    </Wrapper>
  );
}
